import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
});

// Returns relative path; callers prepend BACKEND_URL.
export const imageUrl = (id) => `/api/images/${id}/file`;

export async function generateImage({ prompt, model }) {
  const { data } = await api.post("/generate", { prompt, model });
  return data;
}

export async function listImages() {
  const { data } = await api.get("/images");
  return data;
}

export async function getImagesCount() {
  const { data } = await api.get("/images/count");
  return data.count;
}

export async function getImage(id) {
  const { data } = await api.get(`/images/${id}`);
  return data;
}
